/*
 * ProductScreen.jsx — ARGO
 */
import React from 'react';
import styled from 'styled-components';

const BLUE   = '#00C2FF';
const PURPLE = '#7B61FF';

const Overlay = styled.div`
  position: fixed; inset: 0;
  background: rgba(3,8,23,.92); backdrop-filter: blur(20px);
  display: flex; flex-direction: column;
  align-items: center; justify-content: flex-end;
  padding-bottom: max(32px, env(safe-area-inset-bottom));
  z-index: 100;
`;
const Card = styled.div`
  width: min(100%, 480px);
  background: rgba(8,27,58,.8); backdrop-filter: blur(18px);
  border: 0.5px solid rgba(0,194,255,.25);
  border-radius: 24px 24px 0 0; padding: 24px 24px 8px;
`;
const Tag = styled.div`
  font-size: 11px; font-weight: 600; letter-spacing: .14em;
  text-transform: uppercase; color: ${BLUE};
  margin-bottom: 6px; font-family: 'Exo 2', sans-serif;
`;
const Title = styled.h2`
  font-family: 'Exo 2', sans-serif; font-weight: 700;
  font-size: 22px; color: #fff; margin-bottom: 10px; line-height: 1.2;
`;
const Body = styled.p`
  font-size: 14px; line-height: 1.6;
  color: rgba(255,255,255,.8); margin-bottom: 20px;
`;
const Actions = styled.div`
  display: flex; gap: 10px; flex-wrap: wrap; margin-bottom: 16px;
`;
const BtnPrimary = styled.button`
  flex: 1; padding: 13px 18px; border-radius: 14px; border: none;
  cursor: pointer; font-family: 'Exo 2', sans-serif;
  font-weight: 700; font-size: 14px; color: #fff;
  background: linear-gradient(135deg, ${BLUE}, ${PURPLE});
  box-shadow: 0 4px 20px rgba(0,194,255,.3);
  text-decoration: none; display: inline-flex;
  align-items: center; justify-content: center;
  transition: transform .15s;
  &:active { transform: scale(.97); }
`;
const BtnGhost = styled.button`
  flex: 1; padding: 13px 18px; border-radius: 14px;
  border: 0.5px solid rgba(0,194,255,.35); cursor: pointer;
  font-family: 'Exo 2', sans-serif; font-weight: 600; font-size: 14px;
  color: rgba(255,255,255,.9); background: rgba(0,194,255,.08);
  display: inline-flex; align-items: center; justify-content: center; gap: 7px;
  transition: background .15s;
  &:active { background: rgba(0,194,255,.16); }
`;
const CloseBtn = styled.button`
  position: fixed; top: max(20px, env(safe-area-inset-top)); right: 20px;
  width: 40px; height: 40px; border-radius: 50%;
  border: 0.5px solid rgba(255,255,255,.2);
  background: rgba(8,27,58,.7); backdrop-filter: blur(12px);
  color: #fff; cursor: pointer; display: grid; place-items: center;
  z-index: 101; font-size: 18px;
`;

export default function ProductScreen({ product, onBack, onView3D }) {
  if (!product) return null;
  const { info, detach, modelUrl } = product;
  const canView3D = detach?.enabled && modelUrl;

  return (
    <Overlay>
      <CloseBtn onClick={onBack}>✕</CloseBtn>
      <Card>
        <Tag>{info.tag}</Tag>
        <Title>{info.title}</Title>
        <Body>{info.body}</Body>
        <Actions>
          {info.cta?.label && (
            info.cta.url
              ? <BtnPrimary as="a" href={info.cta.url} target="_blank" rel="noopener">{info.cta.label}</BtnPrimary>
              : <BtnPrimary>{info.cta.label}</BtnPrimary>
          )}
          {canView3D && (
            <BtnGhost onClick={() => onView3D?.(product)}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
              </svg>
              {detach.ctaLabel || 'Xem 3D'}
            </BtnGhost>
          )}
        </Actions>
      </Card>
    </Overlay>
  );
}
